import { Component, Input } from "@angular/core";

import { EnergyStatisticsInput } from "./energy-statistics.model";

const labels = {
  consumedTitle: 'Consumed Energy',
  generatedTitle: 'Generated Energy',
  batteryTitle: 'Charge / Discharge Energy',
  gridTitle: 'Import / Export Energy',
  irradiationTitle: 'Irradiation',
  chargeSubtitle: 'Charged',
  dischargeSubtitle: 'Discharged',
  importSubtitle: 'Imported',
  exportSubtitle: 'Exported',
  min: 'Min',
  max: 'Max',
  avg: 'Avg',
  total: 'Total',
};

@Component({
  selector: 'lib-energy-statistics-card',
  templateUrl: './energy-statistics-card.component.html',
  styleUrls: ['./energy-statistics-card.component.scss'],
})
export class EnergyStatisticsCardComponent {
  readonly _labels = labels;
  @Input() locate = 'it-IT';

  @Input() set labels(value: Partial<typeof this._labels>) {
    Object.assign(this._labels, value);
  }
  get labels() {
    return this._labels;
  }

  @Input() data?: EnergyStatisticsInput;
}
